import {REFETCH_DATAGRID_EVENT, RefreshDatagridOptions} from '../hooks/useRefreshServerSideStore';

export const refreshDatagrid = (gridCode: string, options?: RefreshDatagridOptions) => {
  const event = new CustomEvent(REFETCH_DATAGRID_EVENT, {detail: {gridCode, options}});

  window.dispatchEvent(event);
};
